import { render } from "./ListePartenairePage.vue?vue&type=template&id=9f16af40&ts=true"
import script from "./ListePartenairePage.vue?vue&type=script&lang=ts"
export * from "./ListePartenairePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__